
import Card from './WorksAnywhereCard.vue'
export default {
  components: { Card },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    cards: {
      type: Array,
      required: true,
    },
    bgImages: {
      type: Array,
      required: true,
    },
  },
}
